import { Link } from 'react-router-dom';
import { useQuery } from '../lib/useQuery';
import { Shell } from '../components/Shell';
import { useSession } from '../lib/session';
import { Band, Banner, Card, ErrorNote, Loading, Pill, ScrollX } from '../components/ui';
import { Plain } from '../components/Shell';
import type { MasteryBand } from '../lib/types';
import type { ReactNode } from 'react';

/** Reference screens are readable signed out, so the shell is optional. */
function Page({ title, subtitle, children }: { title: string; subtitle?: string; children: ReactNode }) {
  const { user } = useSession();
  if (user) {
    return (
      <Shell title={title} subtitle={subtitle} width="narrow">
        {children}
      </Shell>
    );
  }
  return (
    <Plain tone="app">
      <div style={{ maxWidth: 880, margin: '0 auto', padding: '48px 20px 72px' }}>
        <Link to="/reference" className="small muted">← Reference</Link>
        <h1 style={{ fontSize: 26, fontWeight: 600, letterSpacing: '-0.02em', margin: '14px 0 4px' }}>{title}</h1>
        {subtitle && <p className="muted small" style={{ marginTop: 0 }}>{subtitle}</p>}
        <div className="stack">{children}</div>
      </div>
    </Plain>
  );
}

export function ReferenceIndex() {
  const items = [
    ['/reference/mastery', 'Evidence & mastery model', 'One scale, one drill path, one toggle'],
    ['/reference/compatibility', 'Engagement compatibility', 'What is allowed in which context'],
    ['/reference/vocabulary', 'Vocabulary map', 'What each curriculum calls things'],
    ['/reference/accessibility', 'Accessibility rules', 'Constraints that hold on every screen'],
    ['/reference/copy', 'Copy rules', 'How the product talks'],
    ['/reference/flow-review', 'Flow review', 'What the end-to-end walk turned up'],
  ];
  return (
    <Page title="Reference & rules" subtitle="The constraints the product actually enforces">
      <div className="grid grid--2">
        {items.map(([to, title, note]) => (
          <Link key={to} to={to!} style={{ color: 'inherit' }}>
            <Card title={title} note={note} />
          </Link>
        ))}
      </div>
    </Page>
  );
}

// 5a, 4d, 10a, 10i, 11a and 11b now render their verbatim transcriptions —
// see `bound/Reference.tsx`. Only the index below is hand-built.
